// extracted by mini-css-extract-plugin
export default {"education":"education__IXD2t","logo":"logo__+yjHi","info":"info__1a3fx"};